export default __webpack_public_path__ + "static/media/build-access.ee0e0715.png";